import { Component, OnInit, inject } from '@angular/core';
import { Event, NavigationStart, Router } from '@angular/router';
import { get } from 'lodash';
import config from './config';

/**
 * ACL Component.
 *
 * @exports
 * @class ACLComponent
 */
@Component({ selector: 'app-acl', template: '' })
export class ACLComponent implements OnInit {
  private readonly router = inject(Router);

  /**
   * @description On Init.
   * @memberof ACLComponent
   */
  ngOnInit(): void {
    this.guard();
  }

  /**
   * @description Route guard.
   * @memberof ACLComponent
   */
  guard(): void {
    this.router.events.subscribe({
      /**
       * @description Handle route change.
       * @param {Event} event Router event.
       */
      next: (event: Event) => {
        if (event instanceof NavigationStart) {
          const route = get(config.ROUTES, event.url);
          if (route === false) {
            const url = this.router.routerState.snapshot.url;
            this.router.navigateByUrl(url || '/home', {
              skipLocationChange: !!url
            });
          }
        }
      }
    });
  }
}
